import {mobileImage} from "../mobileAssets";

export default function MobileFooter() {
    return (
        <footer className="mobile_footer mobile-footer-section">
            <img src={mobileImage("mfooter_03.png")} className="footerlogo" alt="月迁网络"/>
            <nav className="desc" aria-label="网站协议">
                <a href="#/user-agreement">用户协议</a>
                <a href="#/privacy-policy">隐私协议</a>
                <a href="#/contact-us">联系我们</a>
            </nav>
            <div className="font">
                <p>沪公网安备31011002007993号</p>
                <p>沪ICP备2024053816号-4</p>
                <p>运营方：上海月迁网络科技有限公司</p>
            </div>
            <div className="font">
                <p>健康游戏忠告：</p>
                <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。</p>
                <p>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
            </div>
        </footer>
    );
}
